<div class="d_principalinf">
    <!--NAV BAR-->
    <div class="izquierda">
        <div class="d_headernavbarlist-int" *ngIf="existenDatos">
            <div class="d_headernavbar" id="d_headernavbar">
                <div class="d_headernavbarhome" [innerHTML]="_icons.home" (click)="onHome()">
                    <span class="d_headernavbarhome-text">Inicio</span>
                </div>
                <nav class="d_headernavbarlist" *ngIf="viewAsignaturas" >
                    <ul class="d_headernavbaroption">
                        <li>|</li>
                        <li>
                            <p-select appendTo="body" [options]="asignaturas_list" [(ngModel)]="selectedAsignatura"
                                optionLabel="label" placeholder="Asignaturas" class="w-full md:w-56"
                                (onChange)="onAsignaturaChange()">
                                <ng-template #selectedItem let-selectedOption>
                                    <div class="flex items-center gap-2" *ngIf="selectedOption"
                                        pTooltip="{{ selectedOption.label }}" tooltipPosition="top">
                                        <div class="d_galeria_asignaturas {{selectedOption.clase}}">
                                            <img [src]="selectedOption.icon" style="width: 2rem; height: 2rem;" />
                                        </div>
                                        <p class="galeria__texto">{{ selectedOption.label }}</p>
                                    </div>
                                </ng-template>
                                <ng-template let-asignatura #item>
                                    <div class="flex items-center gap-2" pTooltip="{{ asignatura.label }}"
                                        tooltipPosition="top">
                                        <div class="d_galeria_asignaturas {{asignatura.clase}}">
                                            <img [src]="asignatura.icon" style="width: 2rem; height: 2rem;" />
                                        </div>
                                        <p class="galeria__texto">{{ asignatura.label }}</p>
                                    </div>
                                </ng-template>
                            </p-select>
                        </li>
                    </ul>
                    <ul class="d_headernavbaroption d_headernavgrades" *ngIf="viewGrados">
                        <li>|</li>
                        <li>
                            <p-select appendTo="body" [options]="grados_list" [(ngModel)]="selectedGrado"
                                optionLabel="label" placeholder="Grados" class="w-full md:w-56"
                                (onChange)="onGradoChange()">
                                <ng-template #selectedItem let-selectedOption>
                                    <div class="flex items-center gap-2" *ngIf="selectedOption">
                                        <span class="d_galeria_numero {{selectedOption.clase}}"
                                            style="width: 2rem; height: 2rem; font-size: 1.5rem;">
                                            {{selectedOption.label}}
                                        </span>
                                    </div>
                                </ng-template>
                                <ng-template let-grado #item>
                                    <div class="flex items-center gap-2">
                                        <span class="d_galeria_numero {{grado.clase}}"
                                            style="width: 2rem; height: 2rem; font-size: 1.5rem;">
                                            {{grado.label}}
                                        </span>
                                    </div>
                                </ng-template>
                            </p-select>
                        </li>
                    </ul>
                    <ul class="d_headernavbaroption"  *ngIf="viewTemas">
                        <li>|</li>
                        <li>
                            <p-select [showClear]="true" [filter]="true" filterBy="label" appendTo="body"
                                [options]="temas_list" [(ngModel)]="selectedTema" optionLabel="label"
                                placeholder="Seleccionar un tema" class="w-full md:w-56" (onChange)="onTemaChange()"
                                pTooltip="{{ selectedTema?.label }}" tooltipPosition="top">
                            </p-select>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
    <!--FILTERS GRL-->
    <div class="derecha">
        <div class="d_headeroption" id="d_headeroption">

            <div class="d_headersearchsec">
                <div [innerHTML]="_icons.search" (click)="openSearch()"></div>




                <div class="d_overlaycontegrl d_search" id="d_overlaycontegrl_search_cont">
                    <!--filtros-->
                    <!-- <div class="d_overlaygrlfilter">d_overlaygrlsearch -->
                    <div class="d_overlaygrlsearch-cont">
                        <!--CLOSE-->
                        <div class="d_overlaygrlsearchclose" [innerHTML]="_icons.times" (click)="openSearch()">

                        </div>

                        <div class="d_overlaysearchgroup">
                            <input class="d_overlaygrlsearchinput2" type="search" (input)="onSearch()"
                                [(ngModel)]="searchTerm">
                            <div class="d_overlaygrlsearchoption2">
                                <ng-container *ngIf="tempAplicaciones.length > 0; else sinResultados">
                                    <ng-container *ngFor="let app of tempAplicaciones">

                                        <!-- <img style="width: 2rem; height: 2rem;"
                                            src="assets/redi/icons/categorias/{{ app.cg.toLocaleLowerCase() | removeAccents  }}.svg" /> -->
                                        <!-- <p-image [src]="url_img_app + app.p + '.png'" alt="Image" width="250"
                                            [preview]="true" /> -->
                                        <span class="d_overlaygrlsearchoptionname"
                                            [innerHTML]="highlightMatch(app.n)"></span>
                                    </ng-container>
                                </ng-container>

                                <ng-template #sinResultados>
                                    <span *ngIf="searchTerm">No se encontraron resultados para : {{ searchTerm }}</span>
                                </ng-template>
                            </div>
                        </div>
                    </div>

                </div>





            </div>



            <!-- ---------FILTERS-------------------- -->

            <div class="d_headerfilter">
                <div [innerHTML]="_icons.filters" (click)="openFilter()"></div>

                <div class="d_overlaycontegrl d_filter" id="d_overlaycontegrl_searchfilter">
                    <!--filtros-->
                    <div class="d_overlaygrlfilter">
                        <!--CLOSE-->
                        <div class="d_overlaygrlsearchclose" [innerHTML]="_icons.times" (click)="openFilter()">

                        </div>

                        <div class="d_overlayfiltergroup">
                            <div class="d_overlayfiltertitle">Categorías:</div>
                            <ng-container *ngFor="let cat of categorias">
                                <label class="d_overlayfilteroption d_categoriassvg"
                                    *ngIf="tempCategorias.includes(cat.label)">
                                    <!-- <input type="checkbox" [id]="cat.id" (change)="cat.action(cat.label)" /> -->
                                    <p-checkbox [(ngModel)]="selectedCategories" name="categorias" [value]="cat"
                                        (onChange)="onCategoryChange($event)"></p-checkbox>

                                    <span [innerHTML]="cat.icon"></span>
                                    <span>{{ cat.label }}</span>
                                </label>
                            </ng-container>
                        </div>

                        <div class="d_btngrl">
                            <span [innerHTML]="_icons.clear" (click)="onClearFilters()"> </span>

                            <p (click)="onClearFilters()">Limpiar filtros</p>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>
